import {
    useMemo,
} from 'react'
import omit from 'lodash/omit'

import {
    DetailPanelComponentProps,
} from 'app/shared-components/SkyNetDataGridExpandable'
import AdditionalFeesForm from 'app/Apps/Pricing/ContractBasis/AdditionalFees/AdditionalFeesForm'
import useGetAdditionalFeesById from 'app/Apps/Pricing/ContractBasis/AdditionalFees/hooks/useGetAdditionalFeesById'
import useContractBasisContext from 'app/Apps/Pricing/ContractBasis/hooks/useContractBasisContext'
import {
    AdditionalFeesStatus,
} from 'app/enums/label.enums'
import useScrollToForm from 'app/hooks/useScrollToForm'
import AdditionalFeesRequests from 'app/requests/ContractBasis/AdditionalFees.requests'
import StatusHandler from 'app/shared-components/StatusHandler'
import WarningCard from 'app/shared-components/WarningCard'

export default function AdditionalFeesCopy({
    id,
    onCancel,
    onSuccess,
}: Readonly<DetailPanelComponentProps & { id: number }>) {
    const scrollToForm = useScrollToForm(`scroll-to-${id}`)

    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
    } = useGetAdditionalFeesById(id)

    const requestParams = useMemo(() => {
        return AdditionalFeesRequests.duplicate({
            id: data?.id,
        })
    }, [data?.id])

    const {
        contractId,
        currency,
    } = useContractBasisContext()

    const valueCleaned = useMemo(() => {
        return {
            ...omit(data, [
                'id',
                'createdOn',
                'createdBy',
                'changedBy',
                'changedOn',
                'additionalFeesNumber',
                'contractWithCurrencyId',
                'supportingDocuments',
                'fees',
            ]),
            contractId,
            currency,
            additionalFeesStatus: AdditionalFeesStatus.IN_PROGRESS,
            additionalFeesId: data?.id,
        }
    }, [
        data,
        contractId,
        currency,
    ])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <div
                ref={scrollToForm}
            >
                <WarningCard>You are deep copying an additional fee.</WarningCard>
                <AdditionalFeesForm
                    value={valueCleaned}
                    onSuccess={onSuccess}
                    onCancel={onCancel}
                    requestParams={requestParams}
                />
            </div>
        </StatusHandler>
    )
}
